/**
 * 무로그인 공개 라우트 판정 — router.beforeEach 가드와 App.vue 레이아웃이 공유하는 단일 지점.
 * (SPEC-CHINA-WECHAT-OPEN-PLATFORM-001 F2)
 *
 * 공개 경로는 초대 토큰(256bit)이 방어하므로 로그인 여부와 무관하게 항상 통과시킨다.
 * 가드는 이 경로에서 어떤 redirect 도 하지 않는다 → 다른 경로와 서로 redirect 하는 고리가 생기지 않는다.
 *
 * 정확히 '/wx-authorize' 또는 '/wx-authorize/...' 만 공개다. '/wx-authorize-evil' 같은
 * 접두 문자열 일치로 열리지 않도록 경계('/')를 검사한다.
 */
export const PUBLIC_ROUTE_PREFIXES = ['/wx-authorize'];

export function isPublicRoutePath(path) {
    const p = String(path || '').split(/[?#]/)[0].toLowerCase();
    return PUBLIC_ROUTE_PREFIXES.some((prefix) => p === prefix || p.startsWith(`${prefix}/`));
}

/**
 * 비로그인 사용자의 이동 결정 (router.beforeEach 의 else 분기 로직을 순수 함수로 분리).
 * @param {string} path 이동하려는 경로
 * @param {string} signinPath 로그인 경로
 * @returns {null|string} null 이면 그대로 통과, 문자열이면 그 경로로 redirect
 */
export function resolveGuestRedirect(path, signinPath = '/signin') {
    if (path === signinPath) return null;
    if (path === '/reset-pwd') return null;
    if (isPublicRoutePath(path)) return null;
    return signinPath;
}
